import React from 'react';

import { LeafStateProvider } from 'context/state/leaf';

import { CameraTileContainer } from 'components/camera/CameraTileContainer';

import { AppDeviceLeaf } from 'types/common/leaf';

import styles from './gridView.module.scss';

interface DeviceLeavesProps {
  deviceLeaves: Array<AppDeviceLeaf>;
}

const DevicesGrid = ({ deviceLeaves }: DeviceLeavesProps) =>
  deviceLeaves?.map((device) => (
    <LeafStateProvider key={device.id} leafId={device.id}>
      <CameraTileContainer id={`${device.id}-ctc-grid`} controlDeckType="compact" />
    </LeafStateProvider>
  ));

export interface GridViewProps {
  deviceLeaves: Array<AppDeviceLeaf>;
}

export const GridView = ({ deviceLeaves }: GridViewProps) => (
  <div className={styles.gridView}>
    <DevicesGrid deviceLeaves={deviceLeaves} />
  </div>
);
